import React from "react";
import { Route, Switch } from "react-router-dom";
import Layout from "../components/general/Layout";
import ProductListContainer from "./ProductListContainer";
import ProductSuiteContainer from "./ProductSuiteContainer";
import CreateProductContainer from "./CreateProductContainer";
import CreateProductSuiteContainer from "./CreateProductSuiteContainer";
import ProductGroupContainer from "./ProductGroupContainer";
import CreateProductGroupContainer from "./CreateProductGroupContainer";

export default () => {
  return (
    <Layout>
      <Switch>
        <Route path="/product/list" component={ProductListContainer} />
        <Route path="/product/create" component={CreateProductContainer} />
        <Route
          path="/product/suite/create"
          component={CreateProductSuiteContainer}
        />
        <Route
          path="/product/suite/:productSuiteId/edit"
          component={CreateProductSuiteContainer}
        />
        <Route path="/product/suite" component={ProductSuiteContainer} />
        <Route
          path="/product/group/create"
          component={CreateProductGroupContainer}
        />
        <Route
          path="/product/group/:productGroupId/edit"
          component={CreateProductGroupContainer}
        />
        <Route path="/product/group" component={ProductGroupContainer} />
      </Switch>
    </Layout>
  );
};
